
import { useAuthStore } from "@/lib/auth";

export function SidebarHeader() {
  const { user } = useAuthStore();

  return (
    <div className="py-4 px-2">
      <div className="flex items-center gap-2 px-2">
        {/* AM Logo - Blue rounded square with gradient */}
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 shadow-lg relative overflow-hidden flex items-center justify-center">
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-lg" style={{
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.3) 100%)',
            filter: 'blur(4px)',
            transform: 'scale(1.1)'
          }}></div>
          {/* AM Text */}
          <div className="relative z-10 w-full h-full flex items-center justify-center">
            <span className="text-white font-bold text-base tracking-tight" style={{
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
              letterSpacing: '-0.5px'
            }}>AM</span>
          </div>
          {/* Highlight effect */}
          <div className="absolute top-0 right-0 w-1/2 h-1/2 rounded-tl-lg bg-gradient-to-br from-white/20 to-transparent"></div>
        </div>
        <h2 className="text-xl font-semibold text-gray-900">AM CARE</h2>
      </div>
      {user && (
        <div className="mt-2 px-2 py-2 text-sm">
          <div className="font-medium">Hello {user.name}</div>
          <div className="text-xs text-gray-500 capitalize">{user.role}</div>
        </div>
      )}
    </div>
  );
}
